import React, { FC } from 'react';
import { useRouter } from 'next/router';
import useTranslation from '@hooks/useTranslation';
import ButtonTemplate from '@ui/Button/Button';
import TitleTemplate, { TitleTagTypes } from '@ui/SectionTitle/Title';
import { ROUTES } from '../../constants';
import ContentWrapper from '../../ui/Content/Content';
import {
    Background,
    Section,
    SectionButton,
    SectionDescription,
    SectionHeader,
    Wrapper,
} from './TrainingTypes.elements';

interface TrainingTypesProps {}

const TrainingTypesTemplate: FC<TrainingTypesProps> = () => {
    const { t } = useTranslation();

    const router = useRouter();

    return (
        <Background>
            <ContentWrapper>
                <TitleTemplate tagType={TitleTagTypes.H2} withoutPadding isBlack>
                    {t('about.coursesType.title')}
                </TitleTemplate>
                <Wrapper>
                    <Section>
                        <SectionHeader>{t('about.coursesType.section1.label')}</SectionHeader>
                        <SectionDescription>{t('about.coursesType.section1.description')}</SectionDescription>
                        <SectionButton>
                            <ButtonTemplate
                                onClick={() => router.push({ pathname: ROUTES.TRAININGS })}
                                whiteType
                                text={t('about.coursesType.section1.button')}
                            />
                        </SectionButton>
                    </Section>
                    <Section>
                        <SectionHeader>{t('about.coursesType.section2.label')}</SectionHeader>
                        <SectionDescription>{t('about.coursesType.section2.description')}</SectionDescription>
                        <SectionButton>
                            <ButtonTemplate
                                onClick={() => router.push({ pathname: ROUTES.COMPANY_COURSES })}
                                whiteType
                                text={t('about.coursesType.section2.button')}
                            />
                        </SectionButton>
                    </Section>
                </Wrapper>
            </ContentWrapper>
        </Background>
    );
};
export default TrainingTypesTemplate;
